export enum DashboardPerformanceEnum {
  WEB = 'WEB',
  MOBILE = 'MOBILE',
}
